import React, { Component } from 'react';
import './_preloader.scss'
import { Container,Row,Col,Image } from 'react-bootstrap'
import ShimmerLoader from './ShimmerLoader';

class PreloaderFour extends Component {
    // PreLoaderElement() {
    //     return new Promise(resolve => setTimeout(resolve, 2000))
    // }

    // componentDidMount() {
    //     this.PreLoaderElement().then(() => {
    //         const preloaderEle = document.getElementById('preloader')
    //         if (preloaderEle) {
    //             // fade out
    //             preloaderEle.classList.add('available')
    //             setTimeout(() => {
    //                 // remove from DOM
    //                 preloaderEle.outerHTML = ''
    //             }, 1000)
    //         }
    //     })
    // }

    render() {
        return (
            <Container>
                <Row>
                    <Col sm={12}>
                        <ShimmerLoader />
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default PreloaderFour;